<template>
  <v-card flat class="hidden-md-and-down">
    <v-btn text tile class="grey lighten-5 hidden-md-and-down" @click="toggleFullscreen">
      <v-icon v-if="fullscreen">mdi-fullscreen-exit</v-icon>
      <v-icon v-else>mdi-fullscreen</v-icon>
      <span v-if="fullscreen">Exit</span>
      <span v-else>View</span>
      <br />Fullscreen
    </v-btn>

    <v-btn text tile class="grey lighten-4 hidden-md-and-down" @click="toggleToolbar">
      <v-icon v-if="appBarVisible">mdi-crop-square</v-icon>
      <v-icon v-else>mdi-dock-top</v-icon>
      <span v-if="appBarVisible">Hide</span>
      <span v-else>Show</span>
      <br />Toolbars
    </v-btn>

    <!-- <v-btn text tile class="grey lighten-3 hidden-md-and-down" v-if="isPaperView">
      <v-icon>mdi-select-compare</v-icon>
      <span>
        &nbsp;
        <br />
      </span>
      <br />Thumbnails
    </v-btn>-->
  </v-card>
</template>

<script>
export default {
  name: "NavActions",
  data: () => ({
    fullscreen: false,
  }),
  props: {
    isPaperView: {
      type: Boolean,
      default: false,
    },
    appBarVisible: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    toggleFullscreen() {
      this.$fullscreen.toggle();
      this.fullscreen = !this.fullscreen;
    },
    toggleToolbar() {
      this.$emit("toggleAppToolbar");
    },
  },
};
</script>

<style lang="scss" scoped>
.v-card {
  margin: -0.5rem 0;
  border-radius: 0;
  margin-right: 1rem;

  ::v-deep .v-btn {
    font-size: 0.65rem;
    height: 100% !important;

    .v-btn__content {
      flex-direction: column;
      line-height: 1;
      letter-spacing: 0;

      i {
        margin-bottom: 0.5rem;
      }
    }
  }
}
</style>